import { DataTableColumnHeader } from 'components/ui/DataTable';
// import { DataTableActions } from 'components/ui/DataTableActions';
import { ColumnDef } from '@tanstack/react-table';
import { Checkbox } from 'components/ui/checkbox';
import { InvoiceStatusIcon } from '../StatusIcon';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { useAuth } from 'hooks';
import { OrderItem } from 'contracts/OrderItems';

export function useColumns() {
  const { userBelongsToAnyOf } = useAuth();

  let columns: ColumnDef<any>[] = [];

  if (userBelongsToAnyOf('admin') || userBelongsToAnyOf('warehouseMember')) {
    columns.push({
      id: 'select',
      header: ({ table }) => (
        <Checkbox
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() && 'indeterminate')
          }
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
        />
      ),
      cell: ({ row }) => (
        <Checkbox
          checked={row.getIsSelected()}
          // disabled={row.original.status !== 'aguardando'}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label="Select row"
        />
      ),
      enableSorting: false,
      enableHiding: false,
    });
  }

  columns.push(
    {
      id: 'id',
      accessorKey: 'id',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="ID" />
      ),
      enableSorting: true,
      enableHiding: false,
    },
    // {
    //   id: 'wmsId',
    //   accessorKey: 'wmsId',
    //   header: ({ column }) => (
    //     <DataTableColumnHeader column={column} title="WMS Id" />
    //   ),
    //   enableSorting: true,
    //   enableHiding: true,
    // },
    {
      id: 'data',
      accessorKey: 'scheduledAt',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Data" />
      ),
      cell: ({ row }) => {
        const date = new Date(row.original.scheduledAt);
        return format(date, 'dd/MM/yyyy HH:mm', { locale: ptBR });
      },
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'doca',
      accessorKey: 'dock.name',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Doca" />
      ),
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'veiculo',
      accessorKey: 'vehicleType.name',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Veículo" />
      ),
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'placaVeiculo',
      accessorKey: 'vehiclePlate',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Placa" />
      ),
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'transportadora',
      accessorKey: 'carrier.tradeName',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Transportadora" />
      ),
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'cliente',
      accessorKey: 'cliente',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Cliente" />
      ),
      cell: ({ row }) => {
        return row.original.company?.tradeName;
      },
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'volume',
      accessorKey: 'volume',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Volume" />
      ),
      cell: ({ row }) => {
        return row.original.orderItems.reduce(
          (acc: any, item: OrderItem) => acc + item.volume,
          0
        );
      },
      enableSorting: false,
      enableHiding: true,
    },
    {
      id: 'tipo',
      accessorKey: 'orderType.name',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Tipo" />
      ),
      enableSorting: true,
      enableHiding: true,
    },
    {
      id: 'Status',
      accessorKey: 'status',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="" />
      ),
      cell: ({ row }) => {
        return <InvoiceStatusIcon status={row.original.status} />;
      },
      enableSorting: false,
      enableHiding: false,
    }
  );

  return { columns };
}
